import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import { useWindowSize } from 'usehooks-ts'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { AnnotatedImage, AnnotatedScroller } from 'components/AnnotatedScroller'
import { useEffect, useState } from 'react'
import { FrontElement } from 'components/AnnotatedScroller/AnnotatedScroller'
import { NormalBold, NormalNormal, SmallItalic } from 'components/LabelStyles'

const isMobile = window.innerWidth < 712

const debug =
  window.document.title === 'TA-Interaktiv Microfrontend' ? true : false

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  let part = properties?.part || '1'
  const [windowHeight, setWindowHeight] = useState(0)
  const windowSize = useWindowSize()
  const suffix = colorMode === 'dark' ? '_dm' : ''
  useEffect(() => {
    setWindowHeight(windowSize.height)
  }, [windowSize.width])
  useEffect(() => {
    setWindowHeight(windowSize.height)
  }, [])

  return (
    <AppContainer $colorMode={colorMode}>
      {debug && TestText}
      {(part === '1' || debug) && (
        <TextWidth>
          <ImageContainer>
            <img
              src={require('../../assets/illus/gutbacteria' + suffix + '.jpg')}
            />
          </ImageContainer>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '2' || debug) && (
        <TextWidth>
          <div
            style={{
              position: 'relative',
              // height: isMobile ? 450 : 900 + 'px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/cellcommunication' +
                suffix +
                '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>Zelle</NormalNormal>
                    </>
                  ),
                  pos: { x: isMobile?30: 35, y: 15 },
                  offset: { x: isMobile?80: 60, y:0 },
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>Blutgefäss</NormalNormal>
                    </>
                  ),
                  pos: { x: 85, y: 30 },
                  offset: { x: 0, y: isMobile ? -60 : -100 },
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Hormone</NormalBold>
                    </>
                  ),
                  pos: { x: 33, y: 30 },
                  offset: { x: 70, y: 0 },
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Hormon-Rezeptoren</NormalBold>
                    </>
                  ),
                  pos: { x: 59, y: 77.5 },
                  offset: { x: -50, y: 0 },
                },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '3' || debug) && (
        <TextWidth>
          <ImageContainer
            style={{
              position: 'relative',
              // height: isMobile ? 450 : 900 + 'px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/deregulatednutrion' +
                suffix +
                '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>
                        Der Spiegel des Wachstumshormons IGF-1 sollte sich im
                        Alter reduzieren.
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 45, y: 65 },
                  width: 220,
                  offset: { x: 0, y: 40 },
                  align: 'left',
                },
              ]}
            />
          </ImageContainer>
        </TextWidth>
      )}
      {debug && TestText}

      {debug && TestText}
      {(part === '4' || debug) && (
        <TextWidth>
          <div></div>
          <ImageContainer>
            <img
              src={require('../../assets/illus/inflammation' + suffix + '.jpg')}
            />
          </ImageContainer>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '9' || debug) && (
        <AnnotatedScroller
          data={{
            ...proteindata,
            images: [
              {
                src: require('../../assets/illus/proteine_1' + suffix + '.jpg'),
                id: 'proteine_1_a',
                title: '',
                // img: (
                //   <div style={{ width: '100%', height: '100%', background: 'red' }}>
                //     <img src={require('../../assets/illus/proteine_1.jpg')} />
                //   </div>
                // ),
              },
              {
                src: require('../../assets/illus/proteine_2' + suffix + '.jpg'),
                id: 'proteine_1_b',
                title: '',
              },
            ],
          }}
          columnType='TextWidthExtended'
          height={windowHeight}
        />
      )}
      {debug && TestText}
      {(part === '5' || debug) && (
        <TextWidth>
          <div
            style={{
              textAlign: 'left',
              position: 'relative',
              // height: isMobile ? 500 : 950 + 'px',
              marginTop: '90px',
              marginBottom: '90px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/wundheilung' + suffix + '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>
                       Stammzellen sind in allen Phasen der <b>Wundheilung</b> aktiv. Sie wandern in die Wunde ein und differenzieren sich in verschiedene Zelltypen, die für die Heilung benötigt werden.
                      </NormalNormal>
                    </>
                  ),
                  width: 250,
                  pos: { x: 50, y: 0 },
                  offset: { x: 0, y: 0 },
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Entzündungsphase</NormalBold>
                      <NormalNormal>
                  Beginnt unmittelbar nach der Verletzung. Die Blutgefässe verengen sich, um den Blutverlust zu minimieren. Es werden Botenstoffe ausgeschüttet, die Entzündungszellen anlocken.
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 66, y: 18 },
                  offset: { x: 0, y: 0 },
                  width: isMobile ? 240 : 300,
                  align: 'left',
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Resorptionsphase</NormalBold>
                      <NormalNormal>
                      Beginnt ca. 48 Stunden nach der Verletzung. Fresszellen beseitigen tote Zellen und Keime. 

                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 66, y: 40 },
                  offset: { x: 0, y: 0 },
                  width: isMobile ? 240 : 300,
                  align: 'left',
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Proliferationsphase</NormalBold>
                      <NormalNormal>
                     Beginnt ca. 3 Tage nach der Verletzung. Aus Stammzellen bilden sich neue Zellen, die Wunde wird mit neuem Gewebe aufgefüllt.
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 66, y: 62 },
                  offset: { x: 0, y: 0 },
                  width: isMobile ? 240 : 300,
                  align: 'left',
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Reparationsphase</NormalBold>
                      <NormalNormal>
                      Beginnt ca. 2 Wochen nach der Verletzung.Vom Wundrand her entsteht neue Haut, die Wunde schliesst sich. 
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 66, y: 84 },
                  offset: { x: 0, y: 0 },
                  width: isMobile ? 240 : 300,
                  align: 'left',
                },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {(part === '6' || debug) && (
        <TextWidth>
          <div
            style={{
              textAlign: 'left',
              position: 'relative',
              // height: isMobile ? 500 : 950 + 'px',
              marginTop: '90px',
              marginBottom: '90px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/senescentcells' +
                suffix +
                '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>
                        Beschädigte Zellen werden zu sogenannten{' '}
                        <b>alternden Zellen</b>{' '}
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 50, y: 20 },
                  offset: { x: 0, y: 0 },
                  width: 300,
                  align: 'center',
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>
                        Diese rufen im Normalfall das Immunsystem durch
                        Ausschüttung von Botenstoffen zu Hilfe.
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 50, y: 53 },
                  offset: { x: 0, y: 0 },
                  width: 300,
                  align: 'center',
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>
                        Das Immunsystem zerstört darauf hin diese Zellen und
                        säubert damit das Gewebe. Mit zunehmendem Alter versagt
                        dieser Prozess, die alternden Zellen häufen sich im
                        Gewebe an und schädigen es.
                      </NormalNormal>
                    </>
                  ),
                  pos: { x: 50, y: 88 },
                  offset: { x: 0, y: 0 },
                  width: 300,
                  align: 'center',
                },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '7' || debug) && (
        <TextWidth>
          <div
            style={{
              textAlign: 'left',
              position: 'relative',
              // height: isMobile ? 500 : 950 + 'px',
              marginTop: '90px',
              marginBottom: '90px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/muskelathropie' +
                suffix +
                '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Gesunder Muskel</NormalBold>
                    </>
                  ),
                  pos: { x: 50, y: 25 },
                  offset: { x: 0, y: 0 },
                  width: 150,
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Muskelschwund</NormalBold>
                    </>
                  ),
                  pos: { x: 50, y: 70 },
                  offset: { x: 0, y: 0 },
                  width: isMobile ? 200 : 300,
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>
                        Durch den Verlust von Zell&shy;bestand&shy;teilen werden
                        beim <b>Muskelschwund</b> die Muskel&shy;fasern dünner.
                      </NormalNormal>
                    </>
                  ),
                  width: 250,
                  pos: { x: 50, y: 4 },
                  offset: { x: 0, y: 0 },
                },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '8' || debug) && (
        <TextWidth>
          <div
            style={{
              textAlign: 'left',
              position: 'relative',
              // height: isMobile ? 500 : 950 + 'px',
              marginTop: '90px',
              marginBottom: '90px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/fatliver' + suffix + '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>Gesunde Leber</NormalBold>
                    </>
                  ),
                  pos: { x: 50, y: 4 },
                  offset: { x: 0, y: 0 },
                  width: 150,
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalNormal>Fettzellen</NormalNormal>
                    </>
                  ),
                  pos: { x: 65, y: 86 },
                  offset: { x: -20, y: 20 },
                  width: 150,
                },
                {
                  type: 'text',
                  content: (
                    <>
                      <NormalBold>
                        Nichtalkoholische Fettlebererkrankung
                      </NormalBold>
                    </>
                  ),
                  pos: { x: 50, y: 46},
                  offset: { x: 0, y: 0 },
                },
                // {
                //   type: 'text',
                //   content: (
                //     <>
                //       <NormalNormal>
                //         Durch den Verlust von Zell&shy;bestand&shy;teilen werden
                //         beim <b>Muskelschwund</b> die Muskel&shy;fasern dünner.
                //       </NormalNormal>
                //     </>
                //   ),
                //   width: 250,
                //   pos: { x: 50, y: 0 },
                //   offset: { x: 0, y: 0 },
                // },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '10' || debug) && (
        <TextWidth>
          <div
            style={{
              position: 'relative',
              // height: isMobile ? 500 : 900 + 'px',
              marginTop: '90px',
              marginBottom: '90px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/osteoporose' + suffix + '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: (
                    <NormalNormal>
                      Bei einer <b>Osteoporose</b> baut sich die Knochenmasse
                      ab. Die Knochen werden porös und brechen leichter.
                    </NormalNormal>
                  ),
                  width: 300,
                  pos: { x: 50, y: 4 },
                  offset: { x: 0, y: 0 },
                },
                {
                  type: 'text',
                  content: <NormalNormal>Normaler Knochen</NormalNormal>,
                  pos: { x: 60, y: 30 },
                  offset: { x: 0, y: 0 },
                  align: 'left',
                },
                {
                  type: 'text',
                  content: <NormalBold>Osteoporose</NormalBold>,
                  pos: { x: 60, y: 60 },
                  offset: { x: 0, y: 0 },
                  align: 'left',
                },
                {
                  type: 'text',
                  content: <NormalBold>Schwere Osteoporose</NormalBold>,
                  pos: { x: 60, y: 86 },
                  offset: { x: 0, y: 0 },
                  align: 'left',
                },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '11' || debug) && (
        <TextWidth>
          <div
            style={{
              position: 'relative',
              // height: isMobile ? 500 : 900 + 'px',
              marginTop: '90px',
              marginBottom: '90px',
            }}
          >
            <AnnotatedImage
              solo={true}
              img={require('../../assets/illus/telomere' + suffix + '.jpg')}
              annotations={[
                {
                  type: 'text',
                  content: <SmallItalic>Chromosom</SmallItalic>,
                  pos: { x: 25, y: 15 },
                  offset: { x: 0, y: -40 },
                },
                {
                  type: 'text',
                  content: <SmallItalic>Zelle</SmallItalic>,
                  pos: { x: 23.5, y: 32.5 },
                  offset: { x: -20, y: 0 },
                },
                {
                  type: 'text',
                  content: <NormalBold>Zellteilungen</NormalBold>,
                  pos: { x: 24, y: 28 },
                  offset: { x: 0, y: 0 },
                },
                {
                  type: 'text',
                  content: <NormalBold>Telomere</NormalBold>,
                  pos: { x: 50, y: 19 },
                  offset: { x: 40, y: 0 },
                },
              ]}
            />
          </div>
        </TextWidth>
      )}
      {debug && TestText}
      {(part === '12' || debug) && (
        <AnnotatedScroller
          data={{
            ...instabilitydata,
            images: [
              {
                src: require('../../assets/illus/instability' +
                  suffix +
                  '.jpg'),
                id: 'instability_a',
                title: '',
              },
              // {
              //   src: require('../../assets/illus/instability_2' +
              //     suffix +
              //     '.jpg'),
              //   id: 'instability_b',
              //   title: '',
              // },
            ],
          }}
          columnType='TextWidth'
          height={windowHeight}
        />
      )}
      {debug && TestText}
    </AppContainer>
  )
}

const TestText = (
  <>
    <TextWidth>
      <p>
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
        voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
        clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
        amet. Lorem ipsum dolor siast amet, consetetur sadipscing elitr, sed
        diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
        erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et
        ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
        ipsum dolor sit amet.
      </p>
    </TextWidth>
  </>
)
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;

  .Scroller {
  }
  .front {
    pointer-events: none;
  }
  .back {
    pointer-events: all;
  }
`

const ImageContainer = styled.div`
  margin-bottom: 30px;
  img {
    max-width: 100%;
  }
`
export default MainComponent

const proteindata: ScrollerData = {
  frontElements: [
    <FrontElement id='proteine_1_a' distanceTop={900}>
      <b><i>Das passiert:</i></b>  Die Proteine (Eiweisse) sind die Arbeitstiere in unserem Körper. Damit diese richtig funktionieren, braucht es ein grosses Netzwerk an Prozessen, die sicherstellen, dass die Proteine in den richtigen Mengen produziert und richtig gefaltet werden. Man spricht von Homöostase oder Selbstregulierung. Funktioniert diese Selbstregulierung nicht mehr, können zum Beispiel falsch gefaltete Proteine zusammenkleben und Zellen absterben – wie zum Beispiel bei Alzheimer, Parkinson oder Amyotropher Lateralsklerose (ALS). 
    </FrontElement>,
    <FrontElement id='proteine_1_b'>
    <b><i>Das könnte man dagegen tun:</i></b> Funktioniert die Selbstregulierung, dann werden defekte Eiweisse in den Zellen markiert, entsorgt und wiederverwertet. Eine Idee ist es daher, medikamentös diesen Recycling-Prozess zu stärken. Unabhängig davon konnten Forschende in einer Studie mit 200 Patienten, die an der degenerativen Erkrankung ALS leiden, zeigen, dass ein Blutdrucksenker namens Guanabenz das Fortschreiten der tödlichen Erkrankung bremsen kann – möglicherweise indem er die Protein-Selbstregulierung stärkt. 
    </FrontElement>,
  ],
  images: [
    {
      src: require('../../assets/illus/proteine_1.jpg'),
      id: 'proteine_1_a',
      title: 'sssss',
      img: (
        <div style={{ width: '100%', height: '100%', background: 'red' }}>
          <img src={require('../../assets/illus/proteine_1.jpg')} />
        </div>
      ),
    },
    {
      src: require('../../assets/illus/proteine_2.jpg'),
      id: 'proteine_1_b',
      title: 'sfdadfds',
    },
  ],
  annotations: {
    proteine_1_a: [
      {
        type: 'text',
        content: (
          <NormalNormal>Funktionierender Recycling-Prozess</NormalNormal>
        ),
        pos: { x: 50, y: 5 },
        width: 120,
      },
      {
        type: 'text',
        content: (
          <>
            <NormalBold>Korrekt</NormalBold>{' '}
            <NormalNormal>gefaltetes Protein</NormalNormal>
          </>
        ),
        pos: { x: 37, y: 48 },
        offset: { x: isMobile ? -25 : -120, y: -20 },
      },
      {
        type: 'text',
        content: (
          <>
            <NormalBold>Fehlgefaltetes</NormalBold>{' '}
            <NormalNormal>Protein</NormalNormal>
          </>
        ),
        pos: { x: 60, y: 42 },
        offset: { x: isMobile ? 20 : 100, y: -20 },
      },
      {
        type: 'text',
        content: (
          <>
            <NormalNormal>Protein wird markiert</NormalNormal>
          </>
        ),
        pos: { x: 63, y: 59 },
        offset: { x: isMobile ? 20 : 80, y: 10 },
      },
      {
        type: 'text',
        content: (
          <>
            <NormalBold> Proteinkomplex </NormalBold>{' '}
            <NormalNormal>
              zerlegt das fehlgefaltete Protein zur Wiederverwendung
            </NormalNormal>
          </>
        ),
        pos: { x: 55, y: 72 },
        offset: { x: 0, y: isMobile ? 20 : 50 },
        width: 200,
      },
    ],
    proteine_1_b: [
      {
        type: 'text',
        content: (
          <NormalNormal>
            Gestörter
            <br />
            Recycling-Prozess
          </NormalNormal>
        ),
        pos: { x: 50, y: 5 },
        width: 120,
      },
      {
        type: 'text',
        content: (
          <>
            <NormalBold>Fehlgefaltete Proteine</NormalBold>{' '}
            <NormalNormal>
              werden nicht mehr zerlegt, verklumpen und sammeln sich in der
              Zelle.{' '}
            </NormalNormal>
          </>
        ),
        pos: { x: 50, y: 86 },
        width: 200,
      },
    ],
  },
}
const instabilitydata: ScrollerData = {
  frontElements: [
    <FrontElement id='instability_a' distanceTop={900}>
      <i>
        <b>Das passiert:</b>
      </i>{' '}
      Unser Erbgut ist ständig Gefahren ausgesetzt – sei es durch Stoffe aus der
      Nahrung oder aus der Umwelt, sei es durch Fehler beim Kopieren der DNA
      während der Zellteilung. Dabei treiben die Zellen einen grossen Aufwand,
      allfällige Schäden schnell zu reparieren. Trotzdem sammeln sich mit den
      Jahren unzählige Mutationen an. Das führt dazu, dass Zellen ihre Aufgaben
      nicht mehr erledigen können und schliesslich ganze Gewebe beeinträchtigt
      werden – oder dass die Zellen entarten und Tumore, respektive
      Krebsgeschwüre entstehen können.
    </FrontElement>,
    // <FrontElement id='instability_b'>
    //   <i>
    //     <b>Das könnte man dagegen tun: </b>
    //   </i>
    //   Neuere Forschungsergebnisse aus Studien mit Mäusen deuten darauf hin, dass
    //   bestimmte Wirkstoffe einen Reparaturmechanismus des Erbguts verstärken und
    //   so möglicherweise das Altern verlangsamen können.
    // </FrontElement>,
  ],
  images: [
    {
      src: require('../../assets/illus/instability.jpg'),
      id: 'instability_a',
      title: '',
    },
    {
      src: require('../../assets/illus/instability.jpg'),
      id: 'instability_a',
      title: '',
    },
    // {
    //   src: require('../../assets/illus/instability_2.jpg'),
    //   id: 'instability_b',
    //   title: '',
    // },
  ],
  annotations: {
    instability_a: [
      {
        type: 'text',
        content: <NormalNormal>Zufall</NormalNormal>,
        pos: { x: 50, y: 27 },
        offset: { x: 0, y: 0 },
      },
      {
        type: 'text',
        content: <NormalNormal>Krankheits&shy;erreger</NormalNormal>,
        pos: { x: 22, y: 27 },
        offset: { x: 0, y: 0 },
      },
      {
        type: 'text',
        content: <NormalNormal>Lebensstil</NormalNormal>,
        pos: { x: 82, y: 24 },
        offset: { x: 0, y: 0 },
      },
      {
        type: 'text',
        content: <NormalNormal>Erbliche Faktoren</NormalNormal>,
        pos: { x: 22, y: 56 },
        offset: { x: 0, y: 0 },
      },
      {
        type: 'text',
        content: <NormalNormal>Äussere Einflüsse</NormalNormal>,
        pos: { x: 82, y: 61 },
        offset: { x: 0, y: 0 },
      },
    ],

    // instability_b: [
    //   {
    //     type: 'text',
    //     content: (
    //       <NormalNormal>
    //         Auch hier können zukünftige Therapien helfen und die
    //         Reparaturfähigkeit des Erbguts unterstützen.
    //       </NormalNormal>
    //     ),
    //     pos: { x: 50, y: 13 },
    //     offset: { x: 0, y: 0 },
    //     width: 200,
    //   },
    // ],
  },
}
